<template>
  <icon
    class="t-flag-icon"
    :class="[
      { 't-flag-icon--rounded': rounded },
    ]"
    :icon="flagCode"
  />
</template>

<script>
import { Icon } from '@iconify/vue2';
import { flagCodes } from '../../enums';

export default {
  name: 't-flag-icon',

  props: {
    rounded: {
      type: Boolean,
      default: true,
    },

    iso3166_1: {
      type: String,
      required: true,
      validator: (value) => Object.values(flagCodes).includes(value.toLowerCase()),
    },
  },

  computed: {
    flagCode() {
      const code = this.iso3166_1.toLowerCase();
      return `flag:${code}-4x3`;
    },
  },

  components: {
    Icon,
  },
};
</script>
